export default "__VITE_ASSET__CTTsMkkq__"